// extracted by mini-css-extract-plugin
export default {"info":"tweet-info_info__kCpIA","infoLink":"tweet-info_infoLink__RdgYg","infoIcon":"tweet-info_infoIcon__oUIvV"};